// What the sign-in screens may offer (backend: GET /api/auth/options). Text-message
// codes stay hidden until the owner turns them on (SMS_MFA_ENABLED); a failed call
// counts as "off", so an outage never shows a half-working SMS option.
import { useEffect, useState } from 'react';
import axios from 'axios';
import { baseApi } from '../API/api';

export const DEFAULT_AUTH_OPTIONS = Object.freeze({ sms: false, sms_signup: false, sms_international: false });

let pending = null;

export function getAuthOptions() {
  if (!pending) {
    pending = axios.get(`${baseApi}/api/auth/options`)
      .then(({ data }) => ({
        sms: data?.sms === true,
        sms_signup: data?.sms_signup === true,
        sms_international: data?.sms_international === true,
      }))
      .catch(() => {
        pending = null; // ask again next time
        return DEFAULT_AUTH_OPTIONS;
      });
  }
  return pending;
}

/** Tests only: forget the cached answer. */
export function resetAuthOptions() {
  pending = null;
}

/** The options, or null while they load. */
export function useAuthOptions() {
  const [options, setOptions] = useState(null);
  useEffect(() => {
    let live = true;
    getAuthOptions().then((value) => { if (live) setOptions(value); });
    return () => { live = false; };
  }, []);
  return options;
}
